import type {TariffsNddInfo} from '../../../model/tariffs'
import type {NddTariffInfoResponse, PickupStation as RepoPickupStation} from '../../../repo/tariffs'

export function toNddInfoBody(zone: string, tariff: string) {
  return {
    pickup_point_zone_name: zone, // Пока нет ndd, обе точки - текущий город
    dropoff_point_zone_name: zone,
    tariff,
  }
}

export function toTariffsNddInfo({map_polygon, pickup_stations_list}: NddTariffInfoResponse): TariffsNddInfo {
  return {
    mapPolygon: map_polygon,
    pickupStationsList: pickup_stations_list?.points.map(toPickupStation),
  }
}

function toPickupStation(station: RepoPickupStation): RepoPickupStation {
  return {...station}
}
